const getTheme = (themeMode: 'light' | 'dark' | 'system') => {
  if (themeMode === 'system') return 'dark';
  return themeMode;
};

export default getTheme;
